import {
  Layout,
  PageHeader,
  Breadcrumb,
  Row,
  Col,
  Divider,
  Input,
  Icon,
  Select,
  List,
  Spin,
  Typography,
} from "antd";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  setRevisionPriceInfo,
  setRevisionPriceStep,
} from "../../store/actions/revisionPrice";
import { Constant } from "../../config";
import axios from "axios";
import Moment from "react-moment";
import { debounce } from "lodash";
import UserSellPriceModal from "../User/UserManagement/UserSellPriceModal";
import RevisionChangeLogModal from "./Modals/RevisionChangeLog";
import RevisionNoteModal from "./Modals/RevisionNote";
import { checkRolePermission } from "../../services/permission";
import { permissionName, permissionType } from "../../config/permission";

const { Text } = Typography;
const routes = (versionName) => [
  {
    path: "/",
    breadcrumbName: "Home",
  },
  {
    path: "/revision-price/listing",
    breadcrumbName: "Revision Price",
  },
  {
    path: "",
    breadcrumbName: versionName,
  },
];

class RevisionDetail extends Component {
  state = {
    revision: {},
    masterRevisionPrice: [],
    revisionPrice: [],
    versionString: "",
    customerOffers: [],
    revisionId: 0,
    prevRevisionData: {},
    countryList: [],
    currentCustomerPage: 1,
    currentCustomerSearch: "",

    userSellPriceModalVisible: false,
    userSellPriceData: {},

    revisionChangeModalVisible: false,
    revisionNoteModalVisible: false,
    loadingCountry: true,
    loadingCustomers: true,
    canCreate: false,
    canUpdate: false,
  };

  async componentWillMount() {
    if (this.props.match.params.id) {
      // get revision price
      const id = this.props.match.params.id;
      // ? fetch country List
      const countryList = await this._fetchCountryList();

      const revision = await this._fetchRevisionPrice(id, countryList);
      const getPrevRevisionId = () => {
        if (id > 1) {
          return Number(id) - 1;
        }
        return 0;
      };
      let prevRevision = {};

      // ? fetch previous revision version if has any
      const prevRevisionId = getPrevRevisionId();
      if (prevRevisionId !== 0) {
        prevRevision = await this._fetchPrevRevision(
          prevRevisionId,
          countryList
        );
      }

      // ? fetch offer's customer
      const customers = await this._fetchCustomerList(countryList, id);

      const canCreate = checkRolePermission(
        permissionName.REVISION_PRICE,
        permissionType.CREATE
      );
      const canUpdate = checkRolePermission(
        permissionName.REVISION_PRICE,
        permissionType.UPDATE
      );

      this.setState({
        revision: revision,
        revisionPrice: revision["prices"],
        masterRevisionPrice: revision["prices"],
        versionString: revision["name"],
        revisionId: Number(id),
        prevRevisionData: prevRevision,
        countryList: countryList,
        customerOffers: customers,
        loadingCountry: false,
        loadingCustomers: false,
        canCreate,
        canUpdate,
      });
    }
  }
  // trigger event
  _triggerOnEdit = () => {
    // ? addressed to revision price editior by attaching the revision id in url.
    this.props.history.push(`/revision-price/edit/${this.state.revisionId}`);
  };

  onSearchCountry = (event) => {
    event.persist();
    this.setState({
      loadingCountry: true,
    });

    if (!this.debouncedFn) {
      this.debouncedFn = debounce(() => {
        const c = event.target.value;
        if (c.length === 0) {
          this.setState({
            revisionPrice: this.state.masterRevisionPrice,
            loadingCountry: false,
          });
          return;
        }

        const filteredCountry = this.state.masterRevisionPrice.filter(
          (country) =>
            country["country_name"].toLowerCase().includes(c.toLowerCase())
        );

        // ? sort all changes on top
        filteredCountry.sort(function (a, b) {
          const changeLogsA = a["last_change_logs"];
          const changeLogsB = b["last_change_logs"];
          return changeLogsB["price_before"] - changeLogsA["price_before"];
        });

        this.setState({
          revisionPrice: filteredCountry,
          loadingCountry: false,
        });
      }, 600);
    }

    this.debouncedFn();
  };

  onSearchCustomer = (event) => {
    event.persist();
    this.setState({
      loadingCustomers: true,
    });

    if (!this.debouncedFn2) {
      this.debouncedFn2 = debounce(async () => {
        const c = event.target.value;
        if (c.length === 0) {
          const defaultFetch = await this._fetchCustomerList(
            this.state.countryList,
            this.state.revisionId,
            1,
            ""
          );
          this.setState({
            customerOffers: defaultFetch,
            currentCustomerPage: 1,
            currentCustomerSearch: "",
            loadingCustomers: false,
          });
          return;
        }
        const searchedCustomer = await this._fetchCustomerList(
          this.state.countryList,
          this.state.revisionId,
          1,
          c
        );

        this.setState({
          customerOffers: searchedCustomer,
          currentCustomerSearch: c,
          currentCustomerPage: 1,
          loadingCustomers: false,
        });
      }, 600);
    }

    this.debouncedFn2();
  };

  triggerLoadMoreCustomer = async () => {
    this.setState({
      loaingCustomers: true,
    });
    const currentPage = this.state.currentCustomerPage;
    const nextPage = currentPage + 1;

    const nextCustomerArray = await this._fetchCustomerList(
      this.state.countryList,
      this.state.revisionId,
      nextPage,
      this.state.currentCustomerSearch
    );
    const tempCustomerList = [
      ...this.state.customerOffers,
      ...nextCustomerArray,
    ];

    this.setState({
      customerOffers: tempCustomerList,
      currentCustomerPage: nextPage,
      loadingCustomers: false,
    });
  };

  triggerOnCloseSellPriceModal = () => {
    this.setState({
      userSellPriceModalVisible: false,
      userSellPriceData: {},
    });
  };

  triggerSellPriceModal = (record) => {
    if (record.special_offer <= 0) {
      return;
    }

    record["memberId"] = record.id;
    record["memberName"] = record.firstname + " " + record.lastname;

    this.setState({
      userSellPriceModalVisible: true,
      userSellPriceData: record,
    });
  };

  triggerChangeLogModal = () => {
    this.setState({
      revisionChangeModalVisible: true,
    });
  };

  triggerOnCloseRevisionChange = () => {
    this.setState({
      revisionChangeModalVisible: false,
    });
  };

  triggerNoteModal = () => {
    this.setState({
      revisionNoteModalVisible: true,
    });
  };

  triggerOnCloseNoteModal = () => {
    this.setState({
      revisionNoteModalVisible: false,
    });
  };
  // ? fetching
  async _fetchRevisionPrice(id, cl) {
    const url = Constant.REVISION_PRICE_BY_ID_API.replace("[id]", id);
    const opt = {
      url: url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    let data = resp.data;
    data.prices.forEach((p) => {
      const country = cl.find((c) => p.country_abbr === c.region_code);
      if (country) p.country_name = country.name;
    });

    // ? sort all changes on top
    data.prices.sort(function (a, b) {
      const changeLogsA = a["last_change_logs"];
      const changeLogsB = b["last_change_logs"];
      return changeLogsB["price_before"] - changeLogsA["price_before"];
    });

    return data;
  }

  async _fetchPrevRevision(id, cl) {
    const url = Constant.REVISION_PRICE_BY_ID_API.replace("[id]", id);
    let opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }
    let data = resp.data;
    data.prices.forEach((p) => {
      const country = cl.find((c) => p.country_abbr === c.region_code);
      if (country) p.country_name = country.name;
    });

    return data;
  }

  async _fetchCountryList(page = 1, limit = -1) {
    let url = Constant.COUNTRY_API + "?page=" + page + "&limit=" + limit;

    let opt = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    return resp.data.data;
  }

  async _fetchCustomerList(cl, revisionId, page = 1, search = "") {
    const url =
      Constant.MEMBER_API +
      `?revision=${revisionId}&limit=10&page=${page}&search=${search}`;
    const opt = {
      url: url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };

    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      return [];
    }

    if (resp.data.error) {
      return [];
    }

    // ? map country customer
    const data = resp.data.data;
    data.forEach((p) => {
      const country = cl.find((c) => p.country === c.region_code);

      p["country_name"] = ""
      if (country) p["country_name"] = country.name;
    });

    return data;
  }

  //renderer
  renderNote(row) {
    if (!row) {
      return <span>-</span>;
    }

    const { price_before, version_before } = row["last_change_logs"];

    if (price_before === 0) {
      return <span>-</span>;
    }

    return (
      <span>
        {price_before}
        <Icon type="arrow-right" /> {Number(row.price).toFixed(4)} <br />
        From Version {version_before}
      </span>
    );
  }

  render() {
    return (
      <Layout className="revision-detail">
        <Breadcrumb className="breadcrumb">
          {routes(this.state.versionString).map((route) => (
            <Breadcrumb.Item>
              {route.path ? (
                <a href={route.path}>{route.breadcrumbName}</a>
              ) : (
                route.breadcrumbName
              )}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={
            <h2 style={{ fontWeight: "bold" }}>{this.state.versionString}</h2>
          }
          extra={[<a href="/revision-price/listing">{"< Back to listing"}</a>]}
        />
        <div className="container-status">
          <Row type="flex" gutter={24}>
            <Col className="col" style={{ alignSelf: "center" }}>
              <h2 style={{ fontWeight: "bold" }}>{this.state.versionString}</h2>
            </Col>
            <Col className="col">
              <Divider style={{ height: "100%" }} type="vertical" />
            </Col>
            <Col className="col">
              <span style={{ color: "rgb(187 187 187)" }}>Version Code</span>
              <br></br>
              <span
                style={{ fontSize: "18px", fontWeight: "bold", color: "black" }}
              >
                {String(this.state.revision.version).padStart(4, "0")}
              </span>
            </Col>
            <Col className="col">
              <Divider style={{ height: "100%" }} type="vertical" />
            </Col>
            <Col className="col" style={{ textAlign: "center" }}>
              <span style={{ color: "rgb(187 187 187)" }}>Create</span>
              <br></br>
              <span style={{ color: "black" }}>
                <Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">
                  {this.state.revision.created_date}
                </Moment>
              </span>
            </Col>
            <Col className="col">
              <Divider style={{ height: "100%" }} type="vertical" />
            </Col>
            <Col className="col" style={{ textAlign: "center" }}>
              <span style={{ color: "rgb(187 187 187)" }}>Active</span>
              <br></br>
              <span style={{ color: "black" }}>
                <Moment unix tz="Etc/UTC" format="DD/MM/YYYY HH:mm">
                  {this.state.revision.created_date}
                </Moment>
              </span>
            </Col>
            <Col className="col">
              <Divider style={{ height: "100%" }} type="vertical" />
            </Col>
            <Col className="col" style={{ textAlign: "center" }}>
              <span style={{ color: "rgb(187 187 187)" }}>Status</span>
              <br></br>
              {this.state.revision.next_version !== -1 ? (
                <span style={{ color: "black", fontSize: "16px" }}>
                  Deprecated
                </span>
              ) : (
                <span style={{ color: "#5edf1f", fontSize: "16px" }}>
                  Active
                </span>
              )}
            </Col>
            <Col className="col">
              <Divider style={{ height: "100%" }} type="vertical" />
            </Col>
            <Col className="col" style={{ textAlign: "center" }}>
              <span style={{ color: "rgb(187 187 187)" }}>Customers</span>
              <br></br>
              <span style={{ color: "dodgerblue", margin: "2px 4px" }}>
                <Icon type="user" />
              </span>
              <span
                style={{
                  color: "dodgerblue",
                  fontSize: "18px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                }}
              >
                {this.state.revision.total_member}
              </span>
            </Col>
            <Col
              className="col rvs-detail-action"
              style={{ marginLeft: "auto", marginRight: "24px" }}
            >
              {this.state.canEdit && (
                <a onClick={this._triggerOnEdit}>
                  <Icon type="edit" />
                  &nbsp;
                  <span style={{ textDecoration: "underline" }}>
                    Edit Revision
                  </span>
                </a>
              )}

              <a onClick={this.triggerChangeLogModal}>
                <Icon type="menu" />
                &nbsp;
                <span style={{ textDecoration: "underline" }}>Change Log</span>
              </a>
              <a onClick={this.triggerNoteModal}>
                <Icon type="profile" />
                &nbsp;
                <span style={{ textDecoration: "underline" }}>
                  Revision Note
                </span>
              </a>
            </Col>
          </Row>
        </div>

        <Row className="header-list" type="flex">
          <Col>
            <h3>Revision Sell Price</h3>
          </Col>
          <Col className="with-margin">
            <Input
              prefix={<Icon type="search" />}
              placeholder="Search Country"
              onChange={this.onSearchCountry}
              disabled={this.state.loadingCustomers}
            />
          </Col>
          <Col className="with-margin" style={{ marginLeft: "auto" }}>
            <span>Arrange By</span>{" "}
            <Select defaultValue="default" style={{ margin: "0 12px" }}>
              <Select.Option value="default">Default</Select.Option>
            </Select>
          </Col>
        </Row>

        <div className="header-list revise-country-wrap">
          <Row
            type="flex"
            className="revise-country-header"
            style={{ padding: 0 }}
          >
            <Col span={6} className="text-center">
              Country
            </Col>
            <Col span={6} className="text-center">
              Country Code
            </Col>
            <Col span={6} className="text-center">
              Client Rate
            </Col>
            <Col span={6} className="text-center">
              Note
            </Col>
          </Row>
          <div
            className="revise-country"
            style={{ height: "245px", backgroundColor: "white" }}
          >
            <Spin spinning={this.state.loadingCountry}>
              <List
                dataSource={this.state.revisionPrice}
                renderItem={(item) => (
                  <List.Item key={item.id}>
                    <Row type="flex">
                      <Col
                        span={6}
                        className="text-center"
                        style={{ fontWeight: "bold" }}
                      >
                        {item.country_name}
                      </Col>
                      <Col
                        span={6}
                        className="text-center"
                        style={{ fontWeight: "bold" }}
                      >
                        {item.country_abbr}
                      </Col>
                      <Col
                        span={6}
                        className="text-center"
                        style={{
                          color:
                            item.last_change_logs.price_before > 0
                              ? "dodgerblue"
                              : "black",
                        }}
                      >
                        {item.price.toFixed(4)}
                      </Col>
                      <Col
                        span={6}
                        className="text-center"
                        style={{ color: "rgba(0, 0, 0, 0.45)" }}
                      >
                        {this.renderNote(item)}
                      </Col>
                    </Row>
                  </List.Item>
                )}
              ></List>
            </Spin>
          </div>

          <Text
            type="secondary"
            className="text-scroll"
            style={{ backgroundColor: "white" }}
          >
            Scroll for more
          </Text>
        </div>

        <Row className="header-list" type="flex">
          <Col>
            <h3>Revision's Customers</h3>
          </Col>
          <Col className="with-margin">
            <Input
              prefix={<Icon type="search" />}
              placeholder="Search Customer"
              onChange={this.onSearchCustomer}
              disabled={this.state.loadingCountry}
            />
          </Col>
          <Col className="with-margin" style={{ marginLeft: "auto" }}>
            <span>Arrange By</span>{" "}
            <Select defaultValue="default" style={{ margin: "0 12px" }}>
              <Select.Option value="default">Default</Select.Option>
            </Select>
          </Col>
        </Row>
        <div className="header-list revise-country-wrap">
          <Row
            type="flex"
            className="revise-country-header"
            style={{ padding: 0 }}
          >
            <Col span={5} className="text-center">
              Name
            </Col>
            <Col span={5} className="text-center">
              Country
            </Col>
            <Col span={5} className="text-center">
              Contact
            </Col>
            <Col span={5} className="text-center">
              Avaliable Balance
            </Col>
            <Col className="text-center" span={4}>
              Special Price
            </Col>
          </Row>
          <div
            className="revise-country"
            style={{ height: "300px", backgroundColor: "white" }}
          >
            <Spin spinning={this.state.loadingCustomers}>
              <List
                dataSource={this.state.customerOffers}
                renderItem={(item) => (
                  <List.Item key={item.id}>
                    <Row type="flex">
                      <Col
                        span={5}
                        className="text-center"
                        style={{ fontWeight: "bold" }}
                      >
                        {item.firstname + " " + item.lastname}
                      </Col>
                      <Col
                        span={5}
                        className="text-center"
                        style={{ fontWeight: "bold" }}
                      >
                        {item.country_name}
                      </Col>
                      <Col
                        span={5}
                        className="text-center"
                        style={{ fontWeight: "bold" }}
                      >
                        {item.email} <br></br> {item.tel}
                      </Col>
                      <Col span={5} className="text-center">
                        ${item.balance.toFixed(4)}
                      </Col>
                      <Col span={4} className="text-center">
                        <span
                          style={{
                            textDecoration: "underline",
                            color:
                              item.special_offer > 0
                                ? "dodgerblue"
                                : "rgba(0, 0, 0, 0.45)",
                            cursor: "pointer",
                          }}
                          onClick={() => this.triggerSellPriceModal(item)}
                        >
                          {item.special_offer} Offers
                        </span>
                      </Col>
                    </Row>
                  </List.Item>
                )}
              ></List>
            </Spin>
          </div>

          <a
            type="secondary"
            className="text-scroll"
            style={{ backgroundColor: "white" }}
            onClick={this.triggerLoadMoreCustomer}
          >
            Click for load more
          </a>
        </div>
        {this.state.userSellPriceModalVisible && (
          <UserSellPriceModal
            visible={this.state.userSellPriceModalVisible}
            data={this.state.userSellPriceData}
            countryList={this.state.countryList}
            onCancel={this.triggerOnCloseSellPriceModal}
          />
        )}
        {this.state.revisionChangeModalVisible && (
          <RevisionChangeLogModal
            visible={this.state.revisionChangeModalVisible}
            data={this.state.revision}
            onCancel={this.triggerOnCloseRevisionChange}
            name={this.state.versionString}
            countryList={this.state.countryList}
            canEdit={this.state.canUpdate}
            editCb={this._triggerOnEdit}
          />
        )}
        {this.state.revisionNoteModalVisible && (
          <RevisionNoteModal
            visible={this.state.revisionNoteModalVisible}
            data={this.state.revision}
            onCancel={this.triggerOnCloseNoteModal}
            name={this.state.versionString}
            canEdit={this.state.canUpdate}
            editCb={this._triggerOnEdit}
          />
        )}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    revisionStep: state.revisionPrice.step,
    revisionVersion: state.revisionPrice.version,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setRevisionPriceInfo: ({ version, name, note }) =>
      dispatch(setRevisionPriceInfo({ version, name, note })),
    setRevisionPriceStep: ({ step }) =>
      dispatch(setRevisionPriceStep({ step })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RevisionDetail);



// WEBPACK FOOTER //
// ./src/containers/RevisionPrice/RevisionDetail.js